export default ({...props}) => {
  return `
    margin-bottom: 24px;
    > [ap_atom_name="buttonNotifyPrefsAtom"] {
      width: 100%;
      .MuiFormControlLabel-root{
        display: flex;
        margin-bottom: 8px;
        span:last-child{
          flex-grow: 1;
        }
        [ap_type="row"] {
          align-items: start;
        }
      }
    }
  `
}
